$(document).ready(function () {
    $(".customer-testimonials--container").slick({
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,

        responsive: [],
    });

    $(".testimonial_review").matchHeight();

    // blog slider
    $(".blog__posts").slick({
        autoplay: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        prevArrow: "<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    // custom evetionnts sec

    $(".homeproductt").slick({
        autoplay: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
        prevArrow: "<button type='button' class='slick-prev3 pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
        nextArrow: "<button type='button' class='slick-next3 pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
    });
    // ----------------

    $(".featured--media--inner").slick({
        autoplay: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        appendDots: $(".counter"),
        customPaging: function (slider, i) {
            var total = slider.slideCount;
            var current = i + 1;
            return '<span class="">' + current + "/" + total + "</span>";
        },

        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    // $('.featured--media--inner').on('init beforeChange', function(event, slick, currentSlide, nextSlide) {
    //   var slideCount = slick.slideCount;
    //   $('.total-slides').text(slideCount);
    //   $('.current-slide').text(nextSlide + 1);
    // });
    var $slider = $(".featured--media--inner");
    var $counter = $(".counter");
    var $currentSlide = $(".current-slide", $counter);
    var $totalSlides = $(".total-slides", $counter);

    $slider.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
        var totalSlides = slick.slideCount;
        $totalSlides.text(totalSlides);
        $currentSlide.text(currentSlide + 1);
    });
    $totalSlides.text($slider.slick("getSlick").slideCount);
    // ------------
    $(".slider-arrow--right").click(function () {
        $(this).parents(".featured--media--right").find(".slick-next").click();
    });
    $(".slider-arrow--left").click(function () {
        $(this).parents(".featured--media--right").find(".slick-prev").click();
    });
    // -----------------------
    $(".tab--1").addClass("tab--active");

    $(".tab--heads").click(function () {
        $(this).addClass("tab--active");
        $(this).siblings().removeClass("tab--active");
        var data1 = $(this).attr("data-tab");
        $(".tab--new-man").each(function () {
            var data2 = $(this).attr("data-tab");
            if (data1 == data2) {
                $(this).addClass("tab--block");
                $(this).siblings().addClass("tab--none");
                $(this).siblings().removeClass("tab--block");
                $(".featured--media--inner").slick("slickGoTo", 0);
            }
        });
    });



  // Jquery for Custom Build own burger bar start 

  $(document).on('change', "select[name='properties[Select Quantity:]']", function(){
    var quantityInput = $("input[name='quantity']");
    var increasedValue = parseInt($(this).val());
    quantityInput.val(increasedValue);
  });

  $(document).on('change', ".cbm_1947947_755331", function() {
    var selectedCheckboxes = $(".cbm_1947947_755331:checked");
    
    // if (selectedCheckboxes.length > 2) {
    //   $(".cbm_1947947_755331").prop('disabled', false);
    //   $(this).prop('checked', false); // Uncheck the checkbox if more than two are selected
    // }

    if (selectedCheckboxes.length >= 2) {
      $(".cbm_1947947_755331").not(":checked").prop('disabled', true);
    } else {
      $(".cbm_1947947_755331").not(":checked").prop('disabled', false);
    }
  });
  // Jquery for Custom Build own burger bar end
});
